import { Component, Input } from '@angular/core';
import { AppServiceManager } from "common/services/appServiceManager";
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from "primeng/api";
import { IMemberFeeDetails } from 'app/shared/Domains/feeDetail';
import { IUser } from 'app/shared/Domains/IUser';
import { IVisitor } from 'app/shared/Domains/visitor';
import globalVariable from "../../../globalVariable/globalVariable.json";
import { AppUtils } from 'common/services/app.util';
import { IBranch } from 'app/shared/Domains/branch';
import { ICompany } from 'app/shared/Domains/company';
import { Configuration } from "config/config";
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-visitor',
  templateUrl: './visitor.component.html',
  styleUrls: ['./visitor.component.css']
})
export class VisitorComponent {
  errorExempleNumber: string;
  display: boolean;
  fund: IMemberFeeDetails;
  user: IUser;
  gender = "M";
  companyImage: ICompany
  fullName: any;
  emailAdress: string;
  company: string;
  branch: string;
  address: any;
  selectedBranch: any;
  message: string;
  isSuccess: boolean;
  isError: boolean;
  visitor: IVisitor;
  visitorFee: any;
  feeTotal: number;
  enterSteps: any[];
  currentStep: any;
  isConfirmationBox: any
  mode: string;
  branchName: string;
  activeIndex: any;
  requestGuid: string;

  loading: boolean;
  isMessage: boolean;
  isSubmitted: boolean;
  branchDetail: any;
  requestId: any;
  requesterName: any;

  constructor(public config: Configuration,
    private MessageService: MessageService,
    private appServiceManager: AppServiceManager,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap
      .subscribe(params => {
        console.log('company:', params.get('company'));
        console.log('branch:', params.get('branch'));
        this.company = params.get('company');
        this.branch = params.get('branch');
        this.getBranchById();
        // this.branches = this.branches.filter(branch => branch._id == this.branch);
        // if (this.branches.length > 0) {
        //   this.selectedBranch = this.branches[0];
        //   // console.log( this.selectedBranch);
        // }
        // else {
        //   console.log("Sorry, Please contact your administrator.");
        // }
      });

    this.visitor = new IVisitor();
    this.visitor.feeDetails = [];
    this.fund = new IMemberFeeDetails();
    this.activeIndex = 0;
    this.errorExempleNumber = globalVariable.exampledata.pakNumber;

  }
  getBranchById() {
    this.appServiceManager.get('branches/' + this.branch).subscribe(
      (res) => {
        if (res) {
          this.selectedBranch = res;
          this.branchDetail = res;
        } else {
          this.MessageService.clear();
          this.MessageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.MessageService.clear();
        this.MessageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }
  addFund() {
    if (this.fund.pay !== null && this.fund.pay > 0) {
      var date = new Date();
      this.fund.date = date;
      this.fund.invoice = Math.round(Math.random() * 1000).toString();
      this.fund.status = "Visiting Fee - Paid";
      this.visitor.feeDetails = [];
      this.visitor.feeDetails.push(this.fund);
      this.display = false;
      let user = JSON.parse(localStorage.getItem('currentUser'));
      this.visitor.company = user.company;
      this.visitor.branch = user.branch;
      this.appServiceManager.put("visitors/" + this.visitor._id, this.visitor).subscribe((res: any) => {
        if (res) {
          if (res.error?.isAlreadyExist) {
            this.MessageService.clear();
            this.MessageService.add({ severity: 'error', summary: 'Error Message', detail: 'Name and contact already exists.' });
          }
          else {
            this.visitor = res.visitor;
            setTimeout(() => {
              this.printInvoice();
            }, 200);
            this.visitor.date = new Date(this.visitor.date);
            if (this.visitor.dateOfBirth) {
              this.visitor.dateOfBirth = new Date(this.visitor.dateOfBirth);
            }
            this.calculateTotal();
            this.MessageService.clear();
            this.MessageService.add({ severity: 'success', summary: 'Success Message', detail: 'Visitor Successfully Updated' });
          }
        } else {
          this.display = false;
          this.MessageService.clear();
          this.MessageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error) => {
          this.display = false;
          this.MessageService.clear();
          this.MessageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    } else {
      this.MessageService.clear();
      this.MessageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Visiting Fee Must be greater then zero.' });
    }
  }
  errorMsgClose() {
    this.isMessage = false;
    this.isError = false;
    this.isSuccess = false;
  }
  submit(form: any) {
    if (form.valid) {

      let payload = form.value;
      this.requesterName = form.value.name;
      payload['gender'] = this.gender;
      payload['company'] = this.company;
      payload['branch'] = this.branch;

      this.appServiceManager
        .post("requests/visitor", payload)
        .subscribe(
          (res: any) => {
            if (res.status === true) {
              this.requestId = res.visitor.requestId
              this.requestGuid = res.visitor._id;
              this.calculateTotal();
              form.reset();
              this.isSuccess = true;
              this.isError = false;
              this.activeIndex = 1;
              this.isMessage = true;
            } else {
              this.message = "Sorry, Something went wrong.";
              this.isMessage = true;
              this.isSuccess = false;
              this.isError = true;
            }
          },
          (error: any) => {
            this.isMessage = true;
            this.message = "Sorry, Something went wrong.";
            this.loading = false;
            this.isSuccess = false;
            this.isError = true;
          });

    }
    else {
      //  // Form validation error handling
      Object.keys(form.controls).forEach(controlName => {
        const control = form.controls[controlName];
        control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
    }
  }

  openWhatsApp(): string {

    let reciever = this.branchDetail.whatsapp;
    if (this.branchDetail.phone) {
      let msg = this.config.visitorRegistrationMessage;
      msg = msg.replace("{0}", this.requestId);
      msg = msg.replace("{1}", this.requestGuid);
      msg = msg.replace("{2}", this.requesterName);

      const message = encodeURIComponent(msg);

        const link = document.createElement('a');
        link.href = `https://wa.me/${reciever}?text=${message}`;
        link.target = '_blank';
        link.click();
        return '';
    } else {
      // Show error message here
      this.MessageService.clear();
      this.MessageService.add({
        severity: "error",
        summary: "Error Message",
        detail: 'This user does not have a phone number',
      });
      return '';
    }
  }
  hotkeys($event) {
    if ($event.keyCode == 39 || $event.keyCode == 37) {
      var confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
      var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
      var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;
      if (confirmationBoxButtonExistLength > 0) {
        if (document.activeElement.tagName === "BODY") {
          confirmationBoxButtonExist[0].focus();
        }
        else {
          if (document.activeElement === confirmationBoxButtonExist[0]) {
            confirmationBoxButtonExist[1].focus();
          }
          else if (document.activeElement === confirmationBoxButtonExist[1]) {
            confirmationBoxButtonExist[0].focus();
          }
          else {
            confirmationBoxButtonExist[0].focus();
          }
        }
      }
    }

    else if ($event.keyCode == 13 && !this.isConfirmationBox) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      var nextId = this.enterSteps[nextStep];
      let ele: any = document.getElementById(nextId)
      if (ele == null && nextId == "visitorFee" && this.mode == "edit") {
        document.getElementById("visitorUpdate").focus();
        this.currentStep = 0 - 1;
      }
      else if (nextId == "visitorGender") {
        let radioClassFocus: any = document.getElementsByClassName("p-highlight")[1] as HTMLElement;
        radioClassFocus.click();
        this.currentStep = 1;
      } else if (ele.disabled && nextId == "visitorSave") {
        document.getElementById("visitorName").focus();
        this.currentStep = 0;
      } else if (ele.disabled && nextId == "visitorUpdate") {
        document.getElementById("visitorName").focus();
        this.currentStep = 0;
      } else {
        ele.focus();
        this.currentStep = nextStep;
      }
    }
    else if ($event.keyCode == 113) {
      this.router.navigateByUrl("/visitor");
      this.visitor.name = "";
      this.visitor.email = "";
      this.visitor.phone = "";
      this.visitor.gender = 'M';
      this.fund.pay = undefined;
      this.visitor.date = new Date();
      document.getElementById("visitorName").focus();
      this.currentStep = 0;
    }
  }

  hotClick($event) {
    let currentClickLocation = $event.target.id;
    let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
    if (indexOfClickField !== -1 && (currentClickLocation != "opt1" || currentClickLocation != "opt2")) {
      this.currentStep = indexOfClickField;
    } else if (currentClickLocation == "visitorAddNew") {
      this.visitor.name = "";
      this.visitor.email = "";
      this.visitor.phone = "";
      this.visitor.gender = 'M';
      this.fund.pay = undefined;
      this.visitor.date = new Date();
      document.getElementById("visitorName").focus();
      this.currentStep = 0;
    } else {
      this.currentStep = this.currentStep;
    }
  }

  calculateTotal() {
    this.feeTotal = 0;
    if (this.visitor.feeDetails) {
      if (this.visitor.feeDetails.length > 0) {
        this.visitor.feeDetails.forEach((record) => {
          this.feeTotal += parseInt(record.pay.toString());
        });
      }
    }
  }
  viewPrint(fund) {
    this.fund = new IMemberFeeDetails();
    this.fund = fund;
    setTimeout(() => {
    }, 200);
  }

  printInvoice(): void {
    let printContents: string, popupWin: Window;
    let currentDate = new Date();
    this.branchName = this.selectedBranch.name + " " + currentDate.getDate() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
    printContents = document.getElementById('invoice').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <head>
        <title>${this.branchName}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }
            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }
            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }
            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }
            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }
            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }
            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }
            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }
            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }
            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>
        ${printContents}</body>
    </html>
    `
    );
  }
}
